import axios from "axios";
import router from '../../../router';
import slug from 'slug';
import qs from 'qs';

// initial state
const state = () => ({
    'headers': [],
    'items': []
  })

// getters
const getters = {
    getHeaders(state){
        return state.headers;
    },
    getItems(state){
        return state.items;
    }
}

// actions
const actions = {
    
    getMessages: {
        //root: true,
        handler (context, query){
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: context.rootGetters.getApiUrl + '/api/messages/getMessages',
                    params: query,
                    paramsSerializer: function(params) {
                        return qs.stringify(params, {arrayFormat: 'repeat'})
                    },
                    headers: { 
                        Authorization: 'Bearer ' + context.rootGetters.getToken,
                        Accept: '*/*'
                    }
                })
                .then(response => {
                    //let token = response.data.token;
                    //context.commit('setToken', token);
                    //localStorage.setItem('access_token', token);
                    //let data = JSON.parse(response.data);
                    console.log(response.data);
                    // let headers = [];
                    // let items = [];
                    // response.data.columnNames.forEach(element => {
                    //     headers.push({'text':element, 'value': slug(element)});
                    // });
                    // context.commit('setHeaders', headers);
                    // response.data.columnValues.forEach(element => {
                    //     let item = {};
                    //     for (var i = 0; i < headers.length; i++) {
                    //         item[headers[i].value] = element[i];
                    //     }
                    //     items.push(item);
                    // });
                    // context.commit('setItems', items);
                    // console.log(headers);
                    // console.log(items);
                    resolve(response);
                })
                .catch(error => {

                    if(error.response.status === 401){
                        //context.dispatch('destroyToken');
                        context.dispatch('destroyToken', null, { root: true })
                            .then(() => {
                                router.push({ name: 'login' });
                            })
                    }
                    reject(error);
                })
            });
        }
    },
    getCashInWinningsAsXls: {
        //root: true,
        handler (context, query){
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: context.rootGetters.getApiUrl + '/api/financiar/getCashInWinningsAsXls',
                    params: query,
                    paramsSerializer: function(params) {
                        return qs.stringify(params, {arrayFormat: 'repeat'})
                    },
                    headers: { 
                        Authorization: 'Bearer ' + context.rootGetters.getToken,
                        Accept: '*/*'
                    },
                    responseType: 'arraybuffer'
                })
                .then(response => {

                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'RaportIncasariCastiguri_'+query.dateFrom+'-'+query.dateTo+'.xls');
                    document.body.appendChild(fileLink);

                    fileLink.click();
                    resolve(response);
                })
                .catch(error => {

                    if(error.response.status === 401){
                        //context.dispatch('destroyToken');
                        context.dispatch('destroyToken', null, { root: true })
                            .then(() => {
                                router.push({ name: 'login' });
                            })
                    }
                    reject(error);
                })
            });
        }
    },
    getCashInWinningsByShopCode: {
        //root: true,
        handler (context, query){
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: context.rootGetters.getApiUrl + '/api/financiar/getCashInWinningsByShopCode',
                    params: query,
                    paramsSerializer: function(params) {
                        return qs.stringify(params, {arrayFormat: 'repeat'})
                    },
                    headers: { 
                        Authorization: 'Bearer ' + context.rootGetters.getToken,
                        Accept: '*/*'
                    }
                })
                .then(response => {
                    console.log(response.data);
                    let headers = [];
                    let items = [];
                    response.data.columnNames.forEach(element => {
                        headers.push({'text':element, 'value': slug(element)});
                    });
                    response.data.columnValues.forEach(element => {
                        let item = {};
                        for (var i = 0; i < headers.length; i++) {
                            item[headers[i].value] = element[i];
                        }
                        items.push(item);
                    });
                    let result = {headers, items};
                    resolve(result);
                })
                .catch(error => {

                    if(error.response.status === 401){
                        //context.dispatch('destroyToken');
                        context.dispatch('destroyToken', null, { root: true })
                            .then(() => {
                                router.push({ name: 'login' });
                            })
                    }
                    reject(error);
                })
            });
        }
    },
    getCashInWinningsByShopCodeAsXls: {
        //root: true,
        handler (context, query){
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: context.rootGetters.getApiUrl + '/api/financiar/getCashInWinningsByShopCodeAsXls',
                    params: query,
                    paramsSerializer: function(params) {
                        return qs.stringify(params, {arrayFormat: 'repeat'})
                    },
                    headers: { 
                        Authorization: 'Bearer ' + context.rootGetters.getToken,
                        Accept: '*/*'
                    },
                    responseType: 'arraybuffer'
                })
                .then(response => {

                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'RaportIncasariCastiguri_agentia-'+query.shopCode+'_'+query.dateFrom+'-'+query.dateTo+'.xls');
                    document.body.appendChild(fileLink);

                    fileLink.click();
                    resolve(response);
                })
                .catch(error => {

                    if(error.response.status === 401){
                        //context.dispatch('destroyToken');
                        context.dispatch('destroyToken', null, { root: true })
                            .then(() => {
                                router.push({ name: 'login' });
                            })
                    }
                    reject(error);
                })
            });
        }
    },
}

// mutations
const mutations = {
    setHeaders(state, headers){
        state.headers = headers;
    },
    setItems(state, items){
        state.items = items;
    }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}